<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('driverHistory.title') }} - {{ driverName }}
          </h1>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular :size="70" color="warning" indeterminate />
          </div>
          <!-- Driver history table -->
          <v-layout wrap align-center v-if="!dataIsLoading">
            <v-flex xs12>
              <v-data-table
                id="driverHistory"
                :items="driverHistory.items"
                :headers="headers"
                :loading="isLoading"
                :loading-text="$t('common.table.dataIsLoading')"
                :server-items-length="2"
                :mobile-breakpoint="100"
                class="table-custom driverHistory small mb-4"
                hide-default-footer
              >
                <template slot="item" slot-scope="{ item }">
                  <tr>
                    <td class="text-xs-left">{{ item.num }}</td>
                    <td class="text-xs-left">{{ item.email }}</td>
                    <td class="text-xs-left">{{ item.key }}</td>
                    <td class="text-xs-left details">{{ item.result }}</td>
                    <td class="text-xs-left">{{ item.createdAt }}</td>
                  </tr>
                </template>
                <template slot="no-data">{{
                  $t('common.table.noData')
                }}</template>
              </v-data-table>
              <div v-if="paginationPage" class="text-xs-center">
                <v-pagination
                  :value="paginationPage"
                  :length="paginationLength"
                  @input="choosePaginatorPage($event)"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'DriverHistoryPage',
  components: {},
  data() {
    return {
      dataIsLoading: false,
      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('driverHistory.tableHeaders.user'), sortable: false },
        { text: this.$t('driverHistory.tableHeaders.action'), sortable: false },
        {
          text: this.$t('driverHistory.tableHeaders.details'),
          sortable: false,
        },
        { text: this.$t('driverHistory.tableHeaders.date'), sortable: false },
      ],
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchDriverHistory({
        page: this.paginationPage,
        driverId: this.$route.params.driverId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'global/getLoader',
      driverHistory: 'driver/getDriverHistoryData',
      driverName: 'driver/getDriverName',
    }),
    paginationLength() {
      return this.driverHistory.lastPage;
    },
    paginationPage() {
      if (
        this.driverHistory.currentPage === 1 &&
        this.driverHistory.lastPage === 1
      ) {
        return 0;
      }
      return this.driverHistory.currentPage;
    },
  },
  async created() {
    this.dataIsLoading = true;
    try {
      await this.fetchDriverHistory({
        page: 1,
        driverId: this.$route.params.driverId,
      });
      this.dataIsLoading = false;
    } catch (error) {
      if (error.status === 404) {
        this.$router.push({ name: 'not-found' });
        return;
      }
      this.dataIsLoading = false;
    }
  },
  destroyed() {
    this.clearAlertError();
    this.setDriverHistoryData({});
  },
  methods: {
    ...mapActions({
      fetchDriverHistory: 'driver/fetchDriverHistoryData',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      setLoader: 'global/setLoader',
      setDriverHistoryData: 'driver/setDriverHistoryData',
    }),
    async choosePaginatorPage(page) {
      await this.fetchDriverHistory({
        page,
        driverId: this.$route.params.driverId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
};
</script>

<style lang="scss" scoped></style>
